import type {
  PasswordFieldConfirmOptions,
  PasswordFieldProps,
  PasswordFieldRule,
} from "../password-field.type";

import { LockOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

import { PASSWORD_FIELD_NAME } from "../password-field.constant";

export const PasswordFieldConfirm = ({
  label: customLabel,
  confirmField = PASSWORD_FIELD_NAME,
  ...formItemProps
}: PasswordFieldProps & PasswordFieldConfirmOptions) => {
  const { t } = useTranslation();
  const label = customLabel ?? t("auth:form.confirmPassword.label");

  const rules: PasswordFieldRule[] = [
    { required: true, message: t("auth:form.confirmPassword.errors.empty") },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue(confirmField) === value) {
          return Promise.resolve();
        }
        return Promise.reject(
          new Error(t("auth:form.confirmPassword.errors.dontMatch"))
        );
      },
    }),
  ];

  return (
    <Form.Item
      name="confirmPassword"
      label={label}
      dependencies={[confirmField]}
      rules={rules}
      hasFeedback
      required
      {...formItemProps}
    >
      <Input.Password
        placeholder={label}
        prefix={<LockOutlined className="inputIcon" />}
      />
    </Form.Item>
  );
};
